function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PromiseCache from './promise-cache';
import { setLanguageBundle, updateLanguageBundle } from '@nackle/intl-tools';
export default function (umbrella) {
  var fetch = umbrella.fetch;
  var cache = new PromiseCache();
  var cmxURL = umbrella.isLocalhost() ? 'https://qa.api.biw.cloud/v2/cmx' : "https://".concat(window.location.hostname, "/api/v2/cmx");
  var currentLocale = 'en-US';
  var currentBundle = {};
  var currentBundleNames = [];
  function getBundle(bundleName, locales) {
    return new Promise(function ($return, $error) {
      return Promise.resolve(cache("getBundle:".concat(bundleName, ":").concat(locales.join(':')), function () {
        return new Promise(function ($return, $error) {
          var res, data;
          return Promise.resolve(fetch("".concat(cmxURL, "/bundle/").concat(encodeURIComponent(bundleName)), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              locales: locales
            })
          })).then(function ($await_1) {
            try {
              res = $await_1;
              return Promise.resolve(res.json()).then(function ($await_2) {
                try {
                  data = $await_2;
                  if (res.ok) {
                    return $return(data);
                  } else {
                    return $error(data);
                  }
                  return $return();
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      })()).then($return, $error);
    });
  }
  function getBundleWithAttributes(bundleName, locales) {
    return new Promise(function ($return, $error) {
      return Promise.resolve(cache("getBundleAttributes:".concat(bundleName, ":").concat(locales.join(':')), function () {
        return new Promise(function ($return, $error) {
          var res, data;
          return Promise.resolve(fetch("".concat(cmxURL, "/bundle/").concat(encodeURIComponent(bundleName)), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              locales: locales,
              returnStringAttributes: true
            })
          })).then(function ($await_4) {
            try {
              res = $await_4;
              return Promise.resolve(res.json()).then(function ($await_5) {
                try {
                  data = $await_5;
                  if (res.ok) {
                    return $return(data);
                  } else {
                    return $error(data);
                  }
                  return $return();
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      })()).then($return, $error);
    });
  }
  function getMergedBundle(bundleNames, locale) {
    return new Promise(function ($return, $error) {
      var mergedBundle, bundleData, i;
      mergedBundle = currentBundle;
      if (!locale) {
        locale = getLocale();
      }
      currentLocale = locale;
      if (!bundleNames) {
        bundleNames = currentBundleNames;
      }
      currentBundleNames = [].concat(bundleNames);
      return Promise.resolve(Promise.all(bundleNames.map(function (bundleName) {
        return getBundle(bundleName, [locale]);
      }))).then(function ($await_7) {
        try {
          bundleData = $await_7;
          for (i = 0; i < bundleData.length; i++) {
            mergedBundle = _objectSpread(_objectSpread({}, mergedBundle), bundleData[i].bundles[locale]);
          }
          currentBundle = mergedBundle;
          return Promise.resolve(setLanguageBundle(locale, mergedBundle)).then(function ($await_8) {
            try {
              return $return(currentBundle);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getMergedAttributeBundle(bundleNames, locale) {
    return new Promise(function ($return, $error) {
      var mergedBundle, bundleData, i;
      mergedBundle = currentBundle;
      if (!locale) {
        locale = getLocale();
      }
      currentLocale = locale;
      if (!bundleNames) {
        bundleNames = currentBundleNames;
      }
      currentBundleNames = [].concat(bundleNames);
      return Promise.resolve(Promise.all(bundleNames.map(function (bundleName) {
        return getBundleWithAttributes(bundleName, [locale]);
      }))).then(function ($await_9) {
        try {
          bundleData = $await_9;
          for (i = 0; i < bundleData.length; i++) {
            mergedBundle = _objectSpread(_objectSpread({}, mergedBundle), bundleData[i].bundles[locale]);
          }
          currentBundle = mergedBundle;
          return Promise.resolve(updateLanguageBundle(mergedBundle)).then(function ($await_10) {
            try {
              return $return(currentBundle);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getStringsWithAttributes(bundleName) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var keys, locale;
      keys = $args.length > 1 && $args[1] !== undefined ? $args[1] : [];
      locale = $args.length > 2 ? $args[2] : undefined;
      if (!locale) {
        locale = getLocale();
      }
      return Promise.resolve(cache("getStringsWithAttributes:".concat(bundleName, ":").concat(locale), function () {
        return new Promise(function ($return, $error) {
          var res, data;
          return Promise.resolve(fetch("".concat(cmxURL, "/projects/").concat(encodeURIComponent(bundleName), "/locales/").concat(encodeURIComponent(locale), "/attributes"), {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              keys: keys
            })
          })).then(function ($await_11) {
            try {
              res = $await_11;
              return Promise.resolve(res.json()).then(function ($await_12) {
                try {
                  data = $await_12;
                  if (res.ok) {
                    return $return(data);
                  } else {
                    return $error(data);
                  }
                  return $return();
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      })()).then($return, $error);
    });
  }
  function getLocale() {
    return new Promise(function ($return, $error) {
      return $return(currentLocale);
    });
  }
  function setLocale(locale) {
    return new Promise(function ($return, $error) {
      return Promise.resolve(getMergedBundle(null, locale)).then(function ($await_14) {
        try {
          return $return(currentLocale);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  umbrella.loadBundle = getMergedBundle;
  umbrella.loadStringAttributeBundles = getMergedAttributeBundle;
  umbrella.getStringsWithAttributes = getStringsWithAttributes;
  umbrella.getLocale = getLocale;
  umbrella.setLocale = setLocale;
}
//# sourceMappingURL=content.js.map